import { render, staticRenderFns } from "./SwiperSmallVideo.vue?vue&type=template&id=7fdf19a6&scoped=true"
import script from "./SwiperSmallVideo.vue?vue&type=script&lang=js"
export * from "./SwiperSmallVideo.vue?vue&type=script&lang=js"
import style0 from "./SwiperSmallVideo.vue?vue&type=style&index=0&id=7fdf19a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf19a6",
  null
  
)

export default component.exports